import { render } from "./TicketDueDate.vue?vue&type=template&id=140a3e49&scoped=true"
import script from "./TicketDueDate.vue?vue&type=script&lang=js"
export * from "./TicketDueDate.vue?vue&type=script&lang=js"

import "./TicketDueDate.vue?vue&type=style&index=0&id=140a3e49&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140a3e49"]])

export default __exports__